<template>
  <AppHeader>Bottle Exchange</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class="p-4">
    <div class="flex items-center justify-between text-gray-700 bg-white shadow rounded-t-xl">
      <select v-model="owner_type" class="p-1 w-full rounded-tl-xl bg-white">
        <option value="">-- Owner Type --</option>
        <option value="customer">Customer</option>
        <option value="lead">Lead</option>
      </select>
      <input v-model="date" class="p-1 w-full" type="date">
      <button @click="getData" class="px-4 py-3 text-lg leading-none text-white bg-slate-500 rounded-tr-xl">Filter</button>
    </div>

    <div v-if="entries.length" class="mt-4 responsive-table">
      <table>
        <thead>
          <tr>
            <th>Creator Name</th>
            <th>Owner Name</th>
            <th>Product name</th>
            <th>Type</th>
            <th>Quantity</th>
            <!-- <th>Action</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.id">
            <td>{{ entry.creator_name }}</td>
            <td>{{ entry.owner_name }}</td>
            <td>{{ entry.product_name }}</td>
            <td>{{ entry.type }}</td>
            <td>{{ entry.quantity }}</td>
            <!-- <td>
              <router-link :to="{name: 'BottleExchangeEdit', query: {id: entry.id}}" class="px-2 py-1 text-sm leading-none bg-orange-300 rounded-full"><i class="icon ion-md-create"></i> EDIT</router-link>
            </td> -->
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else>
      <p class="py-10 text-2xl text-center text-gray-400">No Data Found</p>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import mixin from '@/utils/mixin.js';

export default {
  name: 'BottleExchangeIndex',
  mixins: [ mixin ],
  components: { AppHeader, Loading },

  data() {
    return {
      state: 'idle',
      entries: [],
      owner_type: '',
      date: null,
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'customer-bottle-exchange?owner_type=' + this.owner_type + '&date=' + this.date, null, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.entries = resp.data.exchange_entries
        }
      })
    },
  },

  created() {
    let today = new Date();
    this.date = today.toISOString().substr(0, 10);
  },
}
</script>
